import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import CharityGolfTournament from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CharityGolfTournament />
  </React.StrictMode>
);
